import PropTypes from 'prop-types';
import React from 'react';
import {View} from 'react-native';
import RtlAwareStyleSheet from '../../../lib/rtl-aware-stylesheet';
import Icon from '../Icon/Icon';
import theme from '../../../theme-config';

function getStyles() {
  return RtlAwareStyleSheet.create({
    container: {
      paddingHorizontal: 15,
      paddingBottom: 8,
      rtlAware: {
        alignItems: 'flex-end',
      },
    },
    icon: {
      ...theme.listFooterArrow,
      fontSize: 14,
    },
  });
}

const ListViewRowFooter = props => {
  const styles = getStyles();
  const {folded = true} = props;
  const iconName = folded ? 'arrow-down' : 'arrow-up';
  return (
    <View style={styles.container}>
      <Icon name={iconName} style={styles.icon} />
    </View>
  );
};

ListViewRowFooter.propTypes = {
  folded: PropTypes.bool,
};

export default ListViewRowFooter;
